import { render, staticRenderFns } from "./SubpageSavedPayments.vue?vue&type=template&id=3c5f9eee&scoped=true&"
import script from "./SubpageSavedPayments.vue?vue&type=script&lang=js&"
export * from "./SubpageSavedPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f9eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5f9eee')) {
      api.createRecord('3c5f9eee', component.options)
    } else {
      api.reload('3c5f9eee', component.options)
    }
    module.hot.accept("./SubpageSavedPayments.vue?vue&type=template&id=3c5f9eee&scoped=true&", function () {
      api.rerender('3c5f9eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/billingpayment/SubpageSavedPayments.vue"
export default component.exports